import React from 'react'

const RODetailsSinglepage = () => {
    return (
        <div>
            RODetailsSinglepage
        </div>
    )
}

export default RODetailsSinglepage
